import {defineAsyncComponent} from 'vue';

const enactDictionarySetting = defineAsyncComponent(() => import('@/views/enactDictionary/EnactDictionarySetting.vue'));
const addCriteriaEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddCriteriaEnact.vue'),
);
const addCalculationBasisEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddCalculationBasisEnact.vue'),
);
const addCalculationBasisEnactByKind = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddCalculationBasisEnactByKind.vue'),
);
const addExpenseInvestEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddExpenseInvestEnact.vue'),
);
const addExpenseOtherEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddExpenseOtherEnact.vue'),
);
const addExpenseProjectEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddExpenseProjectEnact.vue'),
);
const addExpenseRegularEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddExpenseRegularEnact.vue'),
);
const addExplanationFormEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddExplanationFormEnact.vue'),
);
const addRevenueBudgetEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddRevenueBudgetEnact.vue'),
);
const addRevenueBusinessEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddRevenueBusinessEnact.vue'),
);
const addRevenueFeeEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddRevenueFeeEnact.vue'),
);
const addRevenueOtherEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/dictionary/popup/AddRevenueOtherEnact.vue'),
);
const addPatternEstimateExpenseRegularEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/patternEstimate/popup/AddPatternEstimateExpenseRegularEnact.vue'),
);
const chooseAnotherOrgEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/popup/ChooseAnotherOrgEnact.vue'),
);
const deleteEnactResult = defineAsyncComponent(() => import('@/views/enactDictionary/popup/DeleteEnactResult.vue'));

const orgApplyPopup = defineAsyncComponent(() => import('@/views/enactDictionary/popup/OrgApplyPopup.vue'));

const historyEnact = defineAsyncComponent(() => import('@/views/enactDictionary/popup/HistoryDictionaryEnact.vue'));

const publishEnact = defineAsyncComponent(() => import('@/views/enactDictionary/popup/PublishEnact.vue'));

const infomationOrgPublishEnact = defineAsyncComponent(() =>
  import('@/views/enactDictionary/popup/InfomationOrgPublishEnact.vue'),
);

const explanationDetailPatternPopup = defineAsyncComponent(() =>
  import('@/views/enactDictionary/patternEstimate/popup/ExplanationDetailPatternPopup.vue'),
);

export function registerEnactDictionary(app) {
  app.component('EnactDictionarySetting', enactDictionarySetting);
  app.component('AddCriteriaEnact', addCriteriaEnact);
  app.component('AddCalculationBasisEnact', addCalculationBasisEnact);
  app.component('AddCalculationBasisEnactByKind', addCalculationBasisEnactByKind);
  app.component('AddExpenseInvestEnact', addExpenseInvestEnact);
  app.component('AddExpenseOtherEnact', addExpenseOtherEnact);
  app.component('AddExpenseProjectEnact', addExpenseProjectEnact);
  app.component('AddExpenseRegularEnact', addExpenseRegularEnact);
  app.component('AddExplanationFormEnact', addExplanationFormEnact);
  app.component('AddRevenueBudgetEnact', addRevenueBudgetEnact);
  app.component('AddRevenueBusinessEnact', addRevenueBusinessEnact);
  app.component('AddRevenueFeeEnact', addRevenueFeeEnact);
  app.component('AddRevenueOtherEnact', addRevenueOtherEnact);
  app.component('AddPatternEstimateExpenseRegularEnact', addPatternEstimateExpenseRegularEnact);
  app.component('ChooseAnotherOrgEnact', chooseAnotherOrgEnact);
  app.component('DeleteEnactResult', deleteEnactResult);
  app.component('OrgApplyPopup', orgApplyPopup);
  app.component('HistoryDictionaryEnact', historyEnact);
  app.component('PublishEnact', publishEnact);
  app.component('InfomationOrgPublishEnact', infomationOrgPublishEnact);
  app.component('ExplanationDetailPatternPopup', explanationDetailPatternPopup);
}
